import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { get_qna_list } from "../../Axios";
import Pagination from "../Utility/Pagination";
import { get_day_timestamp } from "../../Validation";

interface Qna {
  ablack_ask_ID : number;
  ablack_ask_progress : number;
  ablack_ask_progress_name : string;
  ablack_ask_division : number;
  ablack_ask_division_name : string;
  ablack_ask_question : string;
  ablack_ask_answer : string;
  ablack_ask_registe : any;
  ablack_ask_modified : string;
  ablack_ask_status : number;
}

const QNA: React.FC = () => {
  const navigate = useNavigate();
  const [qnaList, setQnaList] = useState<Qna[]>([]);
  const [totalQna, setTotalQna] = useState<number>(0);

  const customerData = useSelector((state:RootState) => state.customerData);
  const [page, setPage] = useState<number>(1);
  
  useEffect(() => {
    get_qna_list(
      customerData.customer_ID,
      page
    ).then(result => {
      setQnaList(result.rows);
      setTotalQna(result.total_count);
    });
  }, [customerData.customer_ID, page]);

  const handlePage = (page: number) => {
      setPage(page);
  };
  
  return (
    <S.SectionContainer>
      <S.SectionWidth $width={1080}>
        <S.SectionTitleBox>
          <h1>1:1 문의</h1>
          <h3>운영 시간 내에 문의해주시면 빠른 답변을 받으실 수 있습니다.</h3>
        </S.SectionTitleBox>

        <div
          className="flex justify-end"
        >
          <button
            className="w-[116px] h-[30px] rounded-[15px] border-mainBlack text-mainBlack border-solid border-[0.5px] hover:bg-mainBlack hover:text-mainWhite"
            onClick={() => {
              navigate('/post_qna');
            }}
          >
            문의하기
          </button>
        </div>

        <S.ReservationTableHead className="mt-[13px]">
          <div className="w-[110px]">진행상황</div>
          <div className="w-[110px]">구분</div>
          <div className="w-[250px]">질문</div>
          <div className="w-[380px]">답변</div>
          <div className="w-[110px]">등록일</div>
        </S.ReservationTableHead>

        <div>
          {qnaList.map((tmp, idx) =>
            <S.ReservationTableBody
              $withBtn={false}
              key={tmp.ablack_ask_ID}
              onClick={() => {
                navigate('/qna_select_one', { state : {ablack_ask_ID : tmp.ablack_ask_ID} });
              }}
            >
              <div className="w-[110px]">{tmp.ablack_ask_progress_name}</div>
              <div className="w-[110px]">{tmp.ablack_ask_division_name}</div>
              <div className="w-[250px] text-ellipsis whitespace-nowrap overflow-x-hidden">
                {tmp.ablack_ask_question}
              </div>
              <div className="w-[380px] text-ellipsis whitespace-nowrap overflow-x-hidden">
                {tmp.ablack_ask_answer !== null ? tmp.ablack_ask_answer : <span>-</span>}
              </div>
              <div className="w-[110px]">{get_day_timestamp(tmp.ablack_ask_registe).year_month_day}</div>
            </S.ReservationTableBody>
          )}
        </div>

        <Pagination totalCount={totalQna} handlePage={handlePage} listCount={10} page={page} />
      </S.SectionWidth>
    </S.SectionContainer>
  )
};

export default QNA;